/*
morning Jennifer Du apologies i should've included this information in the protocol.txt:

This game has state that persists between plays.
*NEW PLAYER*
A new player will not have any game state saved. In that case use 'initialPlayerState'
from /config as the starting state.
*ON LOAD*
On load the public player state is delivered to the client by Partner Connect, check its
documentation for instructions on how to read it.
*ON GAME START*
'clientData' contains 'InitialGameState'. This is the state at the start of this game _after_ any
cheat has been applied. The client should set all state at game start according to this property
overriding the platform state.This will ensure the correct function of the game for cheat plays and
replay/restore of all cheat and non-cheat plays.
*/

persistence = {};
persistence.defaultData = {};
persistence.modes = null;
persistence.dataPath = null;
persistence.stakesPerMode = {};
persistence.previousData = {};
persistence.data = {};
persistence.currentMode = 'BASIC';
persistence.currentStake = undefined;
persistence.modeMapping = {};
persistence.lastStakeMapping = {};
persistence.stakeCorrection = {};
persistence.modeStakeMultipliers = {};
persistence.useModes = true;
persistence._ignoreStakeChanges = false;
persistence._lastMode = undefined;
persistence._lastStake = undefined;
persistence._checkCamelCase = true;

persistence.defaultInitData = function (initData) {
  // might be a better way of doing this with $.extend
  if (typeof initData.dataPath !== 'string') {
    initData.dataPath = '';
    console.log('persistence:dataPath not provided');
  }
  if (typeof initData.numWinLines !== 'number') {
    initData.numWinLines = 1;
  }
  if (typeof initData.modes !== 'object') {
    initData.modes = {
      BASIC: {
        coinsizes: [0.1],
        coinsPerBet: 100,
        defaultAmountPerLine: 4,
      },
    };
  }
  if (typeof initData.modeMapping !== 'object') {
    initData.modeMapping = {};
  }
  if (typeof initData.lastStakeMapping !== 'object') {
    initData.lastStakeMapping = {};
  }
  if (typeof initData.stakeCorrection !== 'object') {
    initData.stakeCorrection = {};
  }
  if (typeof initData.modeStakeMultipliers !== 'object') {
    initData.modeStakeMultipliers = {};
  }
  if (typeof initData.checkCamelCase !== 'boolean') {
    initData.checkCamelCase = true;
  }
};

persistence.initialise = function (initData) {
  // we need some config from the config.json file
  // lets get what we need 1st before checking defaults
  // const persistenceConfig = resourceManager.getConfiguration().persistence;
  // initData.dataPath = persistenceConfig.dataPath;

  if (initData.enabled === true) {
    persistence.defaultInitData(initData);
    persistence._checkCamelCase = initData.checkCamelCase;
    persistence.dataPath = initData.dataPath;
    persistence.useModes = initData.useModes ?? true;
    persistence.modeMapping = initData.modeMapping;
    persistence.lastStakeMapping = initData.lastStakeMapping;
    persistence.stakeCorrection = initData.stakeCorrection;
    persistence.modeStakeMultipliers = initData.modeStakeMultipliers;
    persistence.setCurrentMode(initData.currentMode);
    persistence.setDefaultData(initData.defaultData);
    persistence.setModes(initData.modes, initData.numWinLines ? initData.numWinLines : 1);
    persistence.buildDefaultData();
    if (initData.current) {
      // this will be what the player has already achieved on previous games
      // so lets apply that shall we
      persistence.apply(initData.current);
      // and we shouldnt need to worry about restore???
    }

    // listen for specific events like stake change
    messageBus.subscribe('stake:stakeChanged', (stake) => {
      persistence.onStakeChanged(stake);
    });
    messageBus.subscribe('common:RecoverGame', () => {
      persistence.recoverGame();
    });
    messageBus.subscribe('common:RecoverGameDead', () => {
      persistence.recoverGameDead();
    });
  }
};

persistence.recoverGame = function () {
  persistence.recoveringGame = true;
  persistence.setIgnoreStakeChanges(true);
};

persistence.recoverGameDead = function () {
  persistence.recoveringGameDead = true;
};

persistence.setDefaultData = function (defaultData) {
  persistence.defaultData = $.extend(true, {}, persistence.toCamel(defaultData));
};

persistence.setCurrentMode = function (mode) {
  // had mode changed?
  persistence.currentMode = mode;
  // anything else that needs to be done?
  // do we fire anything off if the mode has changed?
  // i dont think we should?
};

persistence.setModes = function (modes, numWinLines = 1) {
  // const expectedmodes = {
  //   "BASIC" : {
  //     "coinsizes":[0.8, ],
  //     "coinsPerBet": 100,
  //     "defaultAmountPerLine": 4
  //   }
  // }
  persistence.modes = Object.keys(modes);
  // we can also build list of stakes per mode now
  for (let i = 0; i < persistence.modes.length; i++) {
    const mode = persistence.modes[i];
    persistence.stakesPerMode[mode] = [];
    for (let s = 0; s < modes[mode].coinSizes.length; s++) {
      let stake = modes[mode].coinSizes[s];
      stake *= numWinLines;
      stake *= persistence.modeStakeMultipliers[mode] ?? 1;
      persistence.stakesPerMode[mode][s] = stake;
    }
  }
};

persistence.buildDefaultData = function () {
  // using default data, build the data for stakes for all modes
  for (let i = 0; i < persistence.modes.length; i++) {
    if (!persistence.data[persistence.modes[i]]) {
      persistence.data[persistence.modes[i]] = {};
    }
    for (let s = 0; s < persistence.stakesPerMode[persistence.modes[i]].length; s++) {
      if (!persistence.data[persistence.modes[i]][persistence.stakesPerMode[persistence.modes[i]][s]]) {
        persistence.data[persistence.modes[i]][persistence.stakesPerMode[persistence.modes[i]][s]] = {};
      }
      persistence.data[persistence.modes[i]][persistence.stakesPerMode[persistence.modes[i]][s]] = $.extend(
        true,
        {},
        persistence.defaultData
      );
    }
  }
};

persistence.getValueByPath = function (obj, path) {
  return path.split('.').reduce((acc, key) => {
    return acc && acc[key];
  }, obj);
};

persistence.apply = function (initial, fireEvent = false) {
  // before we do anything, lets take a copy of the current and back it up to previous
  persistence.previousData = $.extend(true, {}, persistence.data);

  let data = initial;
  if (initial.state && typeof initial.state === 'string') {
    // convert string
    data = JSON.parse(initial.state);
  }

  persistence._lastMode = data[persistence.lastStakeMapping['LASTMODE']];
  persistence._lastStake = data[persistence.lastStakeMapping['LASTSTAKE']];

  // we need to get to the meat of the data
  // we can do this by using dataPath
  const dataAtPath = persistence.getValueByPath(data, persistence.dataPath);
  const modeKeys = persistence.useModes ? Object.keys(dataAtPath) : persistence.modes;

  for (let i = 0; i < modeKeys.length; i++) {
    const modeData = persistence.useModes ? dataAtPath[modeKeys[i]] : dataAtPath;
    const stakeKeys = Object.keys(modeData);
    const modeName = persistence.getMappedModeName(modeKeys[i]);
    const upperName = modeName.toUpperCase();
    // could we just merge away here, without stepping through stakes?
    for (let s = 0; s < stakeKeys.length; s++) {
      const stake = stakeKeys[s];
      if (stake !== '-1') {
        let stakeData = modeData[stake];
        const correctedStake = persistence.correctStake(stake, upperName);
        persistence.data[upperName][correctedStake] = $.extend(
          true,
          persistence.data[upperName][correctedStake],
          persistence.toCamel(stakeData)
        );
      }
    }
  }

  if (fireEvent === true) {
    // normally expected if using a force
    messageBus.postImmediate('persistence:newDataApplied');
  }
};

persistence.getMappedModeName = function (modeName) {
  let mappedModeName = modeName;
  if (persistence.modeMapping[modeName]) {
    mappedModeName = persistence.modeMapping[modeName];
  }
  return mappedModeName;
};

persistence.correctStake = function (stake, mode) {
  let newStake = stake;
  const func = persistence.stakeCorrection[mode];
  if (func) {
    newStake = func(stake);
  }
  return newStake;
};

persistence.getData = function (stake = persistence.currentStake, mode = persistence.currentMode) {
  // we should return a copy of the data so client cant accidently
  // alter it
  const origData = persistence.data[mode][stake] ? persistence.data[mode][stake] : persistence.defaultData;
  const newData = $.extend(true, {}, origData);
  return newData;
};

persistence.getPreviousData = function (stake = persistence.currentStake, mode = persistence.currentMode) {
  // we should return a copy of the data so client cant accidently
  // alter it
  const origData = persistence.previousData[mode][stake]
    ? persistence.previousData[mode][stake]
    : persistence.defaultData;
  const newData = $.extend(true, {}, origData);
  return newData;
};

persistence.onStakeChanged = function (stake) {
  // get the data for this stake
  // and fire an event with the relevant data in it
  if (!persistence._ignoreStakeChanges) {
    //We dont want the persistence to broadcast the "new" data on a recovery.
    const mode = persistence.currentMode;
    persistence.currentStake = stake;
    messageBus.postImmediate('persistence:stakeChanged', {
      stake: stake,
      data: persistence.getData(stake, mode),
    });
  } else if (persistence.recoveringGameDead) {
    //This is assuming we are safe to stop ignoring stake changes as all stake changes are finished but its not 100% certain
    //We cant rely on stake controller messages as they are queued.
    persistence.setIgnoreStakeChanges(false);
    persistence.recoveringGame = false;
    persistence.recoveringGameDead = false;
  }
};

persistence.toCamel = function (o) {
  if (persistence._checkCamelCase !== true) {
    return o;
  }
  let newO, origKey, newKey, value;
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === 'object') {
        value = persistence.toCamel(value);
      }
      return value;
    });
  } else if (typeof o === 'object') {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
        value = o[origKey];
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = persistence.toCamel(value);
        }
        newO[newKey] = value;
      }
    }
  } else {
    newO = { value: o };
  }
  return newO;
};

persistence.getDifferencesBetween2Objects = function (obj1 = persistence.previousData, obj2 = persistence.data) {
  const result = {};

  for (const key in obj1) {
    if (!(key in obj2)) {
      result[key] = { from: obj1[key], to: undefined };
    } else if (
      typeof obj1[key] === 'object' &&
      typeof obj2[key] === 'object' &&
      obj1[key] !== null &&
      obj2[key] !== null
    ) {
      const deepDiff = persistence.getDifferencesBetween2Objects(obj1[key], obj2[key]);
      if (deepDiff !== null) {
        result[key] = deepDiff;
      }
    } else if (obj1[key] !== obj2[key]) {
      result[key] = { from: obj1[key], to: obj2[key] };
    }
  }

  for (const key in obj2) {
    if (!(key in obj1)) {
      result[key] = { from: undefined, to: obj2[key] };
    }
  }

  // If no differences found, return null instead of empty object
  return Object.keys(result).length === 0 ? null : result;
};

persistence.setIgnoreStakeChanges = function (ignore) {
  persistence._ignoreStakeChanges = ignore;
};

// init response
// messageBus.subscribe('spinner:GameConfigEvent', (task) => {
//   // what if the data hasnt been provided?
//   // i think gatiServer / yggservergame should be passing the
//   // data to this object rather than an event? thoughts?
//   // persistence.onGameConfigEvent(task);
// });
// messageBus.subscribe('spinner:SpinEvent', (task) => {
//   // persistence.onSpinEvent(task);
//   // not sure this is needed, connection would need to add data to the task
// });
// messageBus.subscribe('common:GameCompleteEvent', (task) => {
//   // i think the serverParser should be updating persistence
//   // rather than relying on the message queue
//   persistence.onGameCompleteEvent(task);
// });
